var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CaHolderManagerInfoDocument, } from './__generated__/hooks/caHolderManagerInfo.js';
import { LoginGuardianInfoDocument, } from './__generated__/hooks/loginGuardianInfo.js';
// CAHolderManager
const getCAHolderManagerInfo = (apolloClient, params) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield apolloClient.query({
        query: CaHolderManagerInfoDocument,
        variables: params,
    });
    return result;
});
// LoginGuardianType
const getLoginGuardianAccount = (apolloClient, params) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield apolloClient.query({
        query: LoginGuardianInfoDocument,
        variables: params,
    });
    return result;
});
export { getCAHolderManagerInfo, getLoginGuardianAccount };
